/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_Cta_TitleInputs */

const en_fc_home_cta_title = /** @type {(inputs: Fc_Home_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ready for your first FilmCraft edit?`)
};

/**
* | output |
* | --- |
* | "Ready for your first FilmCraft edit?" |
*
* @param {Fc_Home_Cta_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_cta_title = /** @type {((inputs?: Fc_Home_Cta_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_Cta_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_cta_title(inputs)
});
export { fc_home_cta_title as "fc.home.cta.title" }